import React, { useState, useEffect } from "react";
import { Drawer, Descriptions, Divider, Spin, Alert } from "antd";
import api from "../../../../services/api";
import * as DateFormater from "../../../../utils/DateFormater";
import * as MoneyFormater from "../../../../utils/MoneyFormater";
import "./styles.css";

export const ParcelaDetalhes = ({ visible, parcelaId, onClose }) => {
  const [parcela, setParcela] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (visible && parcelaId) {
      fetchParcela();
    }
  }, [visible, parcelaId]);

  const fetchParcela = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get(`/contratos/parcela/${parcelaId}/`);
      setParcela(response.data);
    } catch (err) {
      setError(err.message || "Erro ao buscar detalhes da parcela");
      console.error("Erro ao buscar parcela:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title="Detalhes da Parcela"
      visible={visible}
      onClose={onClose}
      width={600}
      className="parcela-detalhes__drawer"
    >
      {loading && (
        <div className="parcela-detalhes__loading">
          <Spin size="large" />
        </div>
      )}

      {error && (
        <Alert
          message="Erro ao carregar detalhes"
          description={error}
          type="error"
          showIcon
        />
      )}

      {parcela && !loading && (
        <div>
          <Descriptions
            title="Informações Básicas"
            column={1}
            bordered
            size="small"
          >
            <Descriptions.Item label="Número">
              {parcela.num_parcela}º
            </Descriptions.Item>
            <Descriptions.Item label="Vencimento">
              {parcela.dt_vencimento
                ? DateFormater.format(parcela.dt_vencimento)
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Dias em Atraso">
              {parcela.dias_em_atraso || 0}
            </Descriptions.Item>
            <Descriptions.Item label="Situação">
              {parcela.situacao || "-"}
            </Descriptions.Item>
          </Descriptions>

          <Divider />

          <Descriptions title="Valores" column={2} bordered size="small">
            <Descriptions.Item label="Valor Original">
              R$ {MoneyFormater.format(parcela.valor_parcela || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Valor Atualizado">
              R$ {MoneyFormater.format(parcela.valor_atualizado || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Valor Atualizado CC">
              R$ {MoneyFormater.format(parcela.valor_atualizado_cc || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Valor Multa">
              R$ {MoneyFormater.format(parcela.valor_multa || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Valor Mora">
              R$ {MoneyFormater.format(parcela.valor_mora || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Encargos CC">
              R$ {MoneyFormater.format(parcela.encargos_cc || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Tarifas CC">
              R$ {MoneyFormater.format(parcela.tarifas_cc || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Valor Pago">
              R$ {MoneyFormater.format(parcela.valor_pago || 0)}
            </Descriptions.Item>
          </Descriptions>

          <Divider />

          <Descriptions
            title="Juros e Encargos"
            column={2}
            bordered
            size="small"
          >
            <Descriptions.Item label="Outros (Contratado)">
              R$ {MoneyFormater.format(parcela.valor_outros_contratado || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Outros (Atraso)">
              R$ {MoneyFormater.format(parcela.valor_outros_atraso || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Outros (CC)">
              R$ {MoneyFormater.format(parcela.valor_outros_cc || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Juros (Contratado)">
              R$ {MoneyFormater.format(parcela.valor_juros_contratado || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Juros (Atraso)">
              R$ {MoneyFormater.format(parcela.valor_juros_atraso || 0)}
            </Descriptions.Item>
            <Descriptions.Item label="Juros (CC)">
              R$ {MoneyFormater.format(parcela.valor_juros_cc || 0)}
            </Descriptions.Item>
          </Descriptions>

          <Divider />

          <Descriptions title="Datas" column={1} bordered size="small">
            <Descriptions.Item label="Data Entrada TXT">
              {parcela.dt_entrada_txt
                ? DateFormater.format(parcela.dt_entrada_txt)
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Data Saída TXT">
              {parcela.dt_saida_txt
                ? DateFormater.format(parcela.dt_saida_txt)
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Data Remoção TXT">
              {parcela.dt_remocao_txt || "-"}
            </Descriptions.Item>
          </Descriptions>

          {parcela.numero_nf && (
            <div>
              <Divider />
              <Descriptions
                title="Nota Fiscal"
                column={1}
                bordered
                size="small"
              >
                <Descriptions.Item label="Número NF">
                  {parcela.numero_nf}
                </Descriptions.Item>
                <Descriptions.Item label="Status Conciliado">
                  {parcela.status_conciliado || "-"}
                </Descriptions.Item>
              </Descriptions>
            </div>
          )}
        </div>
      )}
    </Drawer>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/ParcelaDetalhes/index.jsx